'use strict';

const DateModel = require('../models/date');
const BaseCollection = require('./base');

class DatesCollection extends BaseCollection {
  initialize() {
    this.model = DateModel;
  }
}

module.exports = DatesCollection;
